import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Cursos from "./pages/Cursos";
import CursosDetalle from "./pages/CursosDetalle";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import ProtectedRoute from "./admin/ProtectedRoute";
import CursosAdmin from "./admin/CursosAdmin";
import ProfesoresAdmin from "./admin/ProfesoresAdmin";
import VentasAdmin from "./admin/VentasAdmin";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Nosotros from "./pages/Nosotros";
import Contacto from "./pages/Contacto";
import Checkout from "./pages/Checkout";
import PaypalTest from "./pages/PaypalTest";
import PagoExitoso from "./pages/PagoExitoso";
import PagoFallido from "./pages/PagoFallido";

function App() {
  return (
    <BrowserRouter>

      {/* NAVBAR SIEMPRE ARRIBA */}
      <Navbar />

      {/* CONTENIDO */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cursos" element={<Cursos />} />
        <Route path="/curso/:id" element={<CursosDetalle />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/checkout/:cursoId" element={<Checkout />} />

        {/* ADMIN */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/cursos"
          element={
            <ProtectedRoute>
              <CursosAdmin />
            </ProtectedRoute>
          }
        />
        <Route path="/pago-exitoso" element={<PagoExitoso />} />
        <Route path="/pago-fallido" element={<PagoFallido />} />
        <Route
          path="/admin/profesores"
          element={
            <ProtectedRoute>
              <ProfesoresAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/ventas"
          element={
            <ProtectedRoute>
              <VentasAdmin />
            </ProtectedRoute>
          }
        />
        <Route path="/paypal-test" element={<PaypalTest />} />
      </Routes>
        {/* FOOTER SIEMPRE ABAJO */}
        <Footer />
    </BrowserRouter>
  );
}
export default App;
